// src/store/popupStore.ts
import { create } from "zustand"

type PopupState = {
  isOpen: boolean
  content: React.ReactNode
  ariaLabel?: string
  position: "anchor-top" | null
  dimmer: "default" | "strong"
  openPopup: (
    content: React.ReactNode,
    position?: "anchor-top",
    dimmer?: "default" | "strong",
    ariaLabel?: string,
  ) => void
  closePopup: () => void
}

export const usePopupStore = create<PopupState>((set) => ({
  isOpen: false,
  content: null,
  position: null,
  dimmer: "default",
  openPopup: (content, position, dimmer = "default", ariaLabel) =>
    set({
      isOpen: true,
      content,
      ariaLabel,
      dimmer,
      ...(position !== undefined && { position }),
    }),
  closePopup: () =>
    set({
      isOpen: false,
      content: null,
      ariaLabel: undefined,
      position: null,
      dimmer: "default",
    }),
}))
